import React, { useEffect, useState, useRef, PureComponent } from 'react';
import { useParams } from 'react-router-dom';
import Header from "../Header";
import Footer from "../Footer";

import { db, storage } from "../../firebase";
import { ref, getDownloadURL, uploadBytesResumable, deleteObject, uploadString } from "firebase/storage";
import { doc, collection, query, orderBy, where, getDoc, getDocs } from "firebase/firestore";

import { useNavigate } from 'react-router-dom';

import { CSVLink, CSVDownload } from "react-csv";

export default function Analytics() {

	const navigate = useNavigate();

	const [project, setProject] = useState(false);
    const [users, setUsers] = useState(false);

    const [projectID, setProjectID] = useState(false);

    const params = useParams();

    const [csvData, setCsvData] = useState(false);
    const [quizAnalytics, setQuizAnalytics] = useState({});

    const setPageProps = async () => {
        if (!!params.id) {
            let projectID = params.id;
            setProjectID(projectID);

            if (projectID) {
                // Get project details
                let snap = await getDoc(doc(db, "projects", projectID));
                let project = snap.data();
                setProject(project);

                // First get the analytics document for this project
                const analyticsDoc = await getDoc(doc(db, "analytics", projectID));
                if (!analyticsDoc.exists()) {
                    setUsers([]);
                    return;
                }

                const analyticsData = analyticsDoc.data();
                const projectUsers = analyticsData.users || [];

                // Only fetch users that are in the analytics document
                let users = [];
                if (projectUsers.length > 0) {
                    const userPromises = projectUsers.map(userId => 
                        getDoc(doc(db, "users", userId))
                    );
                    
                    const userDocs = await Promise.all(userPromises);
                    users = userDocs
                        .filter(doc => doc.exists())
                        .map(doc => {
                            const user = { ...doc.data(), id: doc.id };
                            
                            // Process user progress data
                            if (user.progress && user.progress[projectID]) {
                                // Process packets
                                user.packets = [];
                                user.progress[projectID].packets.forEach((packet) => {
                                    if (packet.packet_completed === true) {
                                        user.packets.push(packet.name);
                                    }
                                });
                                user.packets = user.packets.join(', ');

                                // Process activities
                                user.activities = [];
                                user.quizAnswers = [];
                                user.progress[projectID].packets.forEach((packet) => {
                                    if (packet.activities) {
                                        packet.activities.forEach((activity) => {
                                            if (activity.completed === true) {
                                                user.activities.push(activity.name);
                                            }
                                            if (activity.answer) {
                                                user.quizAnswers.push({
                                                    question: activity.questionText || activity.name,
                                                    answer: activity.selectedAnswer || activity.answer,
                                                    answeredAt: activity.answeredAt,
                                                    packetName: packet.name
                                                });
                                            }
                                        });
                                    }
                                });
                                user.activities = user.activities.join(', ');
                            }
                            
                            return user;
                        });
                }

                // Prepare CSV data
                let csvData = [['Score', 'First Name', 'Last Name', 'Packets Completed', 'Activities Completed', 'Phone', 'Email']];
                for (let user of users) {
                    csvData.push([user.score, user.firstName, user.lastName, user.packets, user.activities, user.phone, user.corporateEmail]);
                }
                setCsvData(csvData);
                setUsers(users);

                // Process quiz analytics
                // Add quiz analytics processing
                let quizStats = {};
                
                users.forEach(user => {
                    user.quizAnswers.forEach(qa => {
                        if (!quizStats[qa.question]) {
                            quizStats[qa.question] = {
                                totalResponses: 0,
                                packetName: qa.packetName,
                                answers: {},
                                firstAnswer: qa.answeredAt,
                                lastAnswer: qa.answeredAt
                            };
                        }
                        
                        quizStats[qa.question].totalResponses++;
                        
                        // Track answer frequencies
                        if (!quizStats[qa.question].answers[qa.answer]) {
                            quizStats[qa.question].answers[qa.answer] = 0;
                        }
                        quizStats[qa.question].answers[qa.answer]++;
                        
                        // Update timestamp ranges
                        const answerDate = new Date(qa.answeredAt);
                        const firstDate = new Date(quizStats[qa.question].firstAnswer);
                        const lastDate = new Date(quizStats[qa.question].lastAnswer);
                        
                        if (answerDate < firstDate) {
                            quizStats[qa.question].firstAnswer = qa.answeredAt;
                        }
                        if (answerDate > lastDate) {
                            quizStats[qa.question].lastAnswer = qa.answeredAt;
                        }
                    });
                });

                // Calculate most popular answers and percentages
                Object.keys(quizStats).forEach(question => {
                    const stats = quizStats[question];
                    let mostPopularAnswer = '';
                    let maxCount = 0;
                    
                    Object.entries(stats.answers).forEach(([answer, count]) => {
                        if (count > maxCount) {
                            mostPopularAnswer = answer;
                            maxCount = count;
                        }
                    });
                    
                    stats.mostPopularAnswer = mostPopularAnswer;
                    stats.mostPopularAnswerCount = maxCount;
                    stats.mostPopularAnswerPercentage = 
                        ((maxCount / stats.totalResponses) * 100).toFixed(1);
                });

                setQuizAnalytics(quizStats);
            }
        }
    };

    useEffect(() => {
        setPageProps();
    }, []);

    var date = new Date();
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    var today = dd + '.' + mm + '.' + yyyy;

    return (
        <div className="page page_analytics">
            <Header />

            {project ?
                <main>
                    <div className="content">
                        <ul className="breadcrumbs">
                            <li>
                                <a href="/">Home</a>
                            </li>
                            <li>
                                <a href="/">Event</a>
                            </li>
                            <li>
                                <span>{project ? project['name'] : ''}</span>
                            </li>
                        </ul>

                        <div className="page__title">
                            <h1>{project ? project['name'] : ''}</h1>
                            <div className="title__buttons">
                                {csvData &&
                                    <CSVLink className="button" filename={"project_users_" + today + ".csv"} data={csvData}>Download Users as CSV</CSVLink>
                                }
								<a className="button" onClick={ () => { navigate("/project/"+projectID) }}>View project</a>
								<a className="button button_edit" onClick={ () => { navigate("/edit/"+projectID) }}>Edit project</a>
                            </div>
                        </div>

                        <div className="columns">
                            <div className="column">
                                <section className="quiz-analytics">
                                    <h2>Quiz Analytics Summary</h2>
                                    {Object.keys(quizAnalytics).length > 0 ? (
                                        <table className="table_border">
                                            <thead>
                                                <tr>
                                                    <th>Packet</th>
                                                    <th>Question</th>
                                                    <th>Total Responses</th>
                                                    <th>Most Popular Answer</th>
                                                    <th>Answer Distribution</th>
                                                    <th>Time Range</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Object.entries(quizAnalytics).map(([question, stats], index) => (
                                                    <tr key={index}>
                                                        <td>{stats.packetName}</td>
                                                        <td>{question}</td>
                                                        <td>{stats.totalResponses}</td>
                                                        <td>
                                                            {stats.mostPopularAnswer}
                                                            <br/>
                                                            <small>
                                                                ({stats.mostPopularAnswerCount} responses - 
                                                                {stats.mostPopularAnswerPercentage}%)
                                                            </small>
                                                        </td>
                                                        <td>
                                                            {Object.entries(stats.answers).map(([answer, count], i) => (
                                                                <div key={i}>
                                                                    {answer}: {count} ({((count/stats.totalResponses)*100).toFixed(1)}%)
                                                                </div>
                                                            ))}
                                                        </td>
                                                        <td>
                                                            <div>First: {new Date(stats.firstAnswer).toLocaleString()}</div>
                                                            <div>Last: {new Date(stats.lastAnswer).toLocaleString()}</div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <div className="loading">No quiz data available</div>
                                    )}
                                </section>

                                <section className="user-list">
                                    <h2>User List</h2>
                                    { !users ?
                                        <div className="loading">
                                            ...loading...
                                        </div>
                                        :
                                        <table className="table_border">
                                            <thead>
                                                <tr>
                                                    <th>Score</th>
                                                    <th>First Name</th>
                                                    <th>Last Name</th>
                                                    <th>Packets Completed</th>
                                                    <th>Activities Completed</th>
                                                    <th>Phone</th>
                                                    <th>Email</th>
                                                    <th>Quiz Answers</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {users.map((user, index) =>
                                                    <tr key={index}>
                                                        <td>{user.score}</td>
                                                        <td>{user.firstName}</td>
                                                        <td>{user.lastName}</td>
                                                        <td>{user.packets}</td>
                                                        <td>{user.activities}</td>
                                                        <td>{user.phone}</td>
                                                        <td>{user.corporateEmail}</td>
                                                        <td>
                                                            {user.quizAnswers.map((qa, i) => (
                                                                <div key={i} style={{marginBottom: '10px'}}>
                                                                    <strong>{qa.packetName} - {qa.question}</strong><br/>
                                                                    Answer: {qa.answer}<br/>
                                                                    {qa.answeredAt && (
                                                                        <small>Answered: {new Date(qa.answeredAt).toLocaleString()}</small>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    }
                                </section>
                            </div>
                        </div>
                    </div>
                </main>
                :
                <>
                </>
            }

            <Footer />
        </div>
    )
}
